import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import { ICON, TEXT } from '../../theme/tokens'

/**
 * Single shared copy-to-clipboard button (v1 had four diverging copies,
 * none of which cleaned up their reset timers).
 */
const CopyButton = ({ text, size = ICON.md }) => {
    const [copied, setCopied] = useState(false)

    useEffect(() => {
        if (!copied) return undefined
        const timer = setTimeout(() => setCopied(false), 2000)
        return () => clearTimeout(timer)
    }, [copied])

    const handleCopy = () => {
        navigator.clipboard.writeText(text)
        setCopied(true)
    }

    return (
        <Tooltip title={copied ? 'Copied!' : 'Copy'}>
            <IconButton
                size="small"
                aria-label={copied ? 'Copied' : 'Copy to clipboard'}
                onClick={handleCopy}
                sx={{
                    color: TEXT.secondary,
                    '&:hover': { color: TEXT.primary },
                }}
            >
                {copied ? (
                    <CheckIcon sx={{ fontSize: size }} />
                ) : (
                    <ContentCopyIcon sx={{ fontSize: size }} />
                )}
            </IconButton>
        </Tooltip>
    )
}

CopyButton.propTypes = {
    text: PropTypes.string.isRequired,
    size: PropTypes.number,
}

export default CopyButton
